/*
 * buecherglanz — 2026-10-01
 * Grund: Gesamtprüfung 2 / PageSpeed (SEO 92 auf Produktseiten, „Links können nicht gecrawlt werden“) – Judge.me hängt
 *   sein Bewertungsfenster an <body>; darin steht ein „Zurück“-Knopf als <a> ohne Linkziel. Für Suchmaschinen sieht das
 *   wie ein kaputter Link aus, mit der Tastatur ist der Knopf nicht erreichbar.
 * Funktion: zeichnet Links ohne Ziel im Judge.me-Fenster als Knopf aus (role="button", tabindex="0") und löst sie mit
 *   Enter oder Leertaste aus. Aussehen und Klick-Verhalten bleiben unverändert. Wartet auf das Fenster, weil Judge.me
 *   es erst nach dem Laden einfügt (höchstens 20 Sekunden), und beobachtet danach nur noch das Fenster selbst.
 * Ohne Abhängigkeiten, lädt mit defer (sections/main-product.liquid). Rückbau: Script-Zeile dort entfernen.
 */
(function () {
  const mark = (modal) => {
    modal.querySelectorAll('a:not([href]):not([role])').forEach((link) => {
      link.setAttribute('role', 'button');
      link.setAttribute('tabindex', '0');
      link.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        link.click();
      });
    });
  };

  const attach = () => {
    const modal = document.querySelector('.jdgm-write-review-modal');
    if (!modal) return false;
    mark(modal);
    // Judge.me baut den Inhalt des Fensters bei Bedarf neu auf
    new MutationObserver(() => mark(modal)).observe(modal, { childList: true, subtree: true });
    return true;
  };

  if (attach()) return;
  // Das Fenster ist ein direktes Kind von <body> – childList ohne subtree genügt
  const observer = new MutationObserver(() => {
    if (attach()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true });
  setTimeout(() => observer.disconnect(), 20000);
})();
